module.exports = __webpack_public_path__ + "media/images/icons/flags/LT-1cbd18db87b33d996ec127b460f89585.svg";